import React, { useEffect, useState } from "react";
import {Pagination, Input, Modal, Table, message, Form, Checkbox, Image, Select, Button, InputNumber} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import UploadImageFormItem from "./UploadImageFormItem";
import {
  getBannersApi,
  updateBannerApi,
  createBannerApi,
  deleteBannerApi,
} from "../../../api/ManageApi";
import GlobalLoader from "../../../components/GlobalLoading";

const Banner = () => {
  const [dataList, setDataList] = useState({data: [], total: 0});
  const [modalItem, setModalItem] = useState<any>();
  const [filter, setFilter] = useState({
    page: 1,
    per_page: 10,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    getBannersApi({
      page: filter.page || 1,
      per_page: filter.per_page || 10,
    }).then((res) => {
      if (res.status) {
        setDataList({
          data: res?.data || [],
          total: res?.paginate?.total_entries || 0
        })
      }
    });
  }, [filter]);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({
      ...modalItem,
      upload: {
        zh: !!modalItem?.asset_url?.zh ? {
          uid: 'zh',
          status: 'done',
          url: modalItem?.asset_url?.zh,
        } : null,
        en: !!modalItem?.asset_url?.en ? {
          uid: 'en',
          status: 'done',
          url: modalItem?.asset_url?.en,
        } : null,
        ja: !!modalItem?.asset_url?.ja ? {
          uid: 'ja',
          status: 'done',
          url: modalItem?.asset_url?.ja,
        } : null
      }
    })
  }, [modalItem, form])

  const handlePageChange = (page: number, per_page: number) => setFilter(data => ({ ...data, page: page, per_page: per_page }));
  const closeModal = () => setModalItem(undefined);
  const handleAdd = () => setModalItem({});

  const columns: ColumnsType<any> = [
    {
      title: "排序权重",
      key: 'sequence',
      width: 100,
      render: (r) => r.sequence
    },
    {
      title: "图片",
      key: 'asset_url',
      width: 250,
      render: (r) => <>
        {
          ['zh', 'en', 'ja'].map(key => (
            <div key={key}>
              {
                !!(r.asset_url || {})[key] ? <>
                  {key}:
                  <Image
                    src={(r.asset_url || {})[key]}
                    preview={true}
                    style={{
                      width: "200px",
                    }}
                  />
                </> : <></>
              }
            </div>
          ))
        }
      </>
    },
    {
      title: "跳转类型",
      key: 'jump_type',
      width: 150,
      render: (r) => r.jump_type === "no_action" ? "无跳转" : "跳转网页"
    },
    {
      title: "跳转设置",
      key: 'jump_config',
      width: 200,
      render: (r) => <span style={{wordBreak: "break-all"}}>{r.jump_config?.url}</span>
    },
    {
      title: "是否启用",
      key: 'is_active',
      width: 100,
      render: (r) => r.is_active ? "✅" : "❌"
    },
    {
      title: "操作",
      key: 'actions',
      width: 150,
      fixed: 'right',
      render: (r) => <>
        <Button type='link' size='small' onClick={() => handleBannerEdit(r)}>编辑</Button>
        <Button type='link' danger size='small' onClick={() => handleBannerDelete(r)}>删除</Button>
      </>
    }
  ]

  const handleBannerDelete = (banner: any) => {
    GlobalLoader.show();
    deleteBannerApi(banner?.id || 0).then((res) => {
      if (res.status) {
        setFilter(data => ({...data }))
      } else {
        message.error(res?.error || '')
      }
      GlobalLoader.hide();
    })
  }

  const handleBannerEdit = (banner: any) => setModalItem(banner)

  const handleSubmit = async () => {
    try {
      await form.validateFields();
    } catch (e) {
      return;
    }
    let data = form.getFieldsValue();
    if(
      (data?.upload?.zh?.status !== 'done' || !data?.upload?.zh?.url) &&
      (data?.upload?.en?.status !== 'done' || !data?.upload?.en?.url) &&
      (data?.upload?.ja?.status !== 'done' || !data?.upload?.ja?.url)
    ){
      message.error("请至少上传一张中文或英文或日文图片")
      return null;
    }
    GlobalLoader.show();
    if(!!data?.id) {
      updateBannerApi({
        id: data?.id,
        sequence: data?.sequence,
        asset_url: {
          zh: data?.upload?.zh?.status === 'done' ? data?.upload?.zh?.url : null,
          en: data?.upload?.en?.status === 'done' ? data?.upload?.en?.url : null,
          ja: data?.upload?.ja?.status === 'done' ? data?.upload?.ja?.url : null,
        },
        jump_type: data?.jump_type,
        jump_config: data?.jump_config,
        is_active: !!data?.is_active,
      }).then((res) => {
        if (res.status) {
          setFilter(data => ({...data }))
          closeModal();
        } else {
          message.error(res?.error || '')
        }
        GlobalLoader.hide();
      })
    } else {
      createBannerApi({
        sequence: data?.sequence,
        asset_url: {
          zh: data?.upload?.zh?.url,
          en: data?.upload?.en?.url,
          ja: data?.upload?.ja?.url,
        },
        jump_type: data?.jump_type,
        jump_config: data?.jump_config,
        is_active: !!data?.is_active,
      }).then((res) => {
        if (res.status) {
          setFilter(data => ({...data, page: 1}))
          closeModal();
        } else {
          message.error(res?.error || '')
        }
        GlobalLoader.hide();
      })
    }
  };

  return (
    <>
      <Modal
        centered
        width={700}
        title={`${!!modalItem?.id ? '编辑' : '创建'}Banner`}
        open={!!modalItem}
        onCancel={(closeModal)}
        onOk={handleSubmit}
      >
        <Form
          form={form}
          style={{margin: '3em 0'}}
          labelCol={{ span: 6 }}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <UploadImageFormItem
            name={"zh"}
            label={"图片（中文）"}
            form={form}
          />
          <UploadImageFormItem
            name={"en"}
            label={"图片（英文）"}
            form={form}
          />
          <UploadImageFormItem
            name={"ja"}
            label={"图片（日文）"}
            form={form}
          />
          <Form.Item
            label={'跳转类型'}
            name="jump_type"
            rules={[{required: true, message: ''}]}>
            <Select options={[
              {label: '无跳转', value: 'no_action'},
              {label: '跳转网页', value: 'web'},
            ]} />
          </Form.Item>
          <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues?.jump_type !== curValues?.jump_type}>
            {() => {
              if (form.getFieldValue("jump_type") === "web") {
                return <>
                  <Form.Item
                    name={["jump_config", "url"]}
                    label={"跳转网页地址"}
                    rules={[
                      {
                        required: true,
                        message: "",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </>;
              } else {
                return <></>;
              }
            }}
          </Form.Item>
          <Form.Item
            label={'排序权重'}
            name="sequence">
            <InputNumber min={0} step={1} style={{width: "100%"}} />
          </Form.Item>
          <Form.Item
            label={"是否生效"}
            name="is_active"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
        </Form>
      </Modal>
      <div style={{display: "flex", justifyContent: 'flex-end', marginBottom: '1em'}}>
        <Button type='primary' onClick={handleAdd}>创建</Button>
      </div>
      <div>
        <Table
          size='small'
          scroll={{ x: 950, scrollToFirstRowOnChange: true }}
          pagination={false}
          rowKey={r => r.id}
          columns={columns}
          dataSource={dataList.data}
        />
        <Pagination
          showTotal={(total) => `共${total}个`}
          current={filter.page}
          pageSize={filter.per_page}
          total={dataList.total}
          onChange={handlePageChange}
          showSizeChanger={false}
          hideOnSinglePage={false}
          style={{textAlign: 'right', justifyContent: 'flex-end', margin: '1em 0'}}
        />
      </div>
    </>
  );
};

export default Banner;